import { useEffect, useState } from 'react'

export default function Banner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(true)
  }, [])

  return (
    <div
      className={`
        relative isolate flex items-center justify-center overflow-hidden
        bg-white px-6 py-2.5 sm:px-3.5
        transition-all duration-700 ease-out border-b-[1px]
        ${show ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}
      `}
    >
      {/* SOL DEKOR */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 blur-2xl"
      >
     
      </div>

      {/* SAĞ DEKOR */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 blur-2xl"
      >
       
      </div>

      {/* İÇERİK – TAM ORTA */}
      <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center">
        <p className="text-sm text-gray-900">
          <strong className="font-semibold">Aysun Şeremet</strong>
          <span className="mx-2">•</span>
          Danışmanlık hakkında bilgi almak için WhatsApp’tan iletişime geçin.
        </p>

        <a
          href="https://wa.me/905372153407"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full bg-green-500 px-4 py-1.5 text-sm font-semibold text-white shadow hover:bg-green-600 transition"
        >
          WhatsApp →
        </a>
      </div>
    </div>
  )
}
